import { format } from "date-fns";

export function hasNonEmptySignatureUrl(signatureUrl?: string | null): boolean {
  return typeof signatureUrl === "string" && signatureUrl.trim().length > 0;
}

/** Treat null, empty, and API values like "undefined undefined" as missing. */
export function formatSignatureByDisplay(value?: string | null): string {
  if (value == null) return "-";
  const trimmed = String(value).trim();
  if (!trimmed) return "-";

  const meaningful = trimmed
    .split(/\s+/)
    .filter((part) => part && part.toLowerCase() !== "undefined")
    .join(" ")
    .trim();

  return meaningful || "-";
}

export function formatSignatureAtDisplay(
  value?: string | null,
  userTimeFormat = "yyyy/MM/dd HH:mm",
): string {
  if (value == null || !String(value).trim()) return "-";
  const date = new Date(value);
  if (isNaN(date.getTime())) return "-";
  return format(date, userTimeFormat);
}
